// extracted by mini-css-extract-plugin
module.exports = {"group":"style_group__2FCSN"};